import type { CSSProperties } from 'react';

/**
 * Перенос `lib/src/config/app_styles.dart`.
 *
 * Размеры шрифта во Flutter заданы без `.sp`, то есть в логических пикселях
 * и без масштабирования — в браузере это те же CSS-пиксели. Поэтому здесь
 * `fontSize` остаётся числом один в один.
 *
 * `lineHeight` соответствует `TextStyle.height` во Flutter: множитель от
 * размера шрифта. В CSS это безразмерный `line-height`.
 */

function style(fontSize: number, fontWeight: number): CSSProperties {
  return { fontSize: `${fontSize}px`, fontWeight };
}

export const AppStyles = {
  s12w600: style(12, 600),
  s32w500: style(32, 500),
  s16w300: style(16, 300),
  s14w300: style(14, 300),
  s14w400: style(14, 400),
  s16w400: style(16, 400),
  s16w600: style(16, 600),
  s20w400: style(20, 400),
  s20w600: style(20, 600),
  s64w600: style(64, 600),
  s36w600: style(36, 600),
  s24w400: style(24, 400),
  s24w600: style(24, 600),
  s40w600: style(40, 600),
} as const;

export type AppStyleName = keyof typeof AppStyles;

/** `AppStyles.s36w600.copyWith(height: 36 / 36)` → `{...s36w600, lineHeight: 1}` */
export function withHeight(base: CSSProperties, height: number): CSSProperties {
  return { ...base, lineHeight: height };
}

/** Числовое значение `fontSize` — нужно для измерения текста на canvas. */
export function fontSizeOf(base: CSSProperties): number {
  return Number.parseFloat(String(base.fontSize ?? '16'));
}

/** Числовое значение `fontWeight`. */
export function fontWeightOf(base: CSSProperties): number {
  return Number(base.fontWeight ?? 400);
}
